// Must match the server enum
export enum AppType {
  None = 0,
  PayApp = 1,
  GpApp = 2,
  LpApp = 3
}

